import { ValueBasedTriggerType } from "@/enum/ValueBasedTriggerType";
import type { IValueBasedTrigger } from "@/interfaces/jobs/IValueBasedTrigger";

class ValueBasedTrigger implements IValueBasedTrigger {
	value: number;
	type: ValueBasedTriggerType;

	constructor(valueBasedTrigger?: any) {
		this.value = valueBasedTrigger?.value ;
		this.type = valueBasedTrigger?.type ?? ValueBasedTriggerType.AtValue;
	}

}

export default ValueBasedTrigger
